import groupBy from 'lodash.groupby';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { TimesheetHolidaysState } from './types';

const selectTimesheetHolidays = (state: AppState): TimesheetHolidaysState =>
    state.timesheetHolidays;

const selectTimesheetHolidaysArray = createDeepEqualSelector(
    selectTimesheetHolidays,
    (timesheetHolidays) => Object.values(timesheetHolidays)
);

const selectTimesheetHolidaysGroupedByDate = createDeepEqualSelector(
    selectTimesheetHolidaysArray,
    (timesheetHolidays) => groupBy(timesheetHolidays, 'date')
);

export {
    selectTimesheetHolidays,
    selectTimesheetHolidaysArray,
    selectTimesheetHolidaysGroupedByDate
};
